"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M23.5 5.04c.28 0 .5.22.5.5V8.5c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1.64C20.33 4.66 17.17 1 12 1 5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11c0-.28.22-.5.5-.5s.5.22.5.5c0 6.62-5.38 12-12 12S0 18.62 0 12 5.38 0 12 0c4.55 0 8.33 2.59 11 7.49V5.54c0-.28.22-.5.5-.5ZM12 5.467a.5.5 0 0 1 .5.5v.291c.713.082 1.39.313 1.934.673.695.46 1.212 1.165 1.212 2.056a.5.5 0 0 1-1 0c0-.463-.261-.89-.764-1.222-.371-.246-.852-.422-1.381-.499v3.907a4.14 4.14 0 0 1 1.974.88c.676.554 1.17 1.343 1.17 2.214 0 .891-.516 1.596-1.211 2.056-.544.36-1.22.59-1.933.673v.285a.5.5 0 0 1-1 0v-.268c-.77-.062-1.482-.302-2.037-.7-.66-.474-1.104-1.18-1.104-2.046a.5.5 0 1 1 1 0c0 .49.242.914.687 1.233.368.264.872.45 1.454.51v-3.902c-1.683-.165-3.132-1.335-3.132-2.932 0-1.598 1.45-2.767 3.132-2.932v-.277a.5.5 0 0 1 .5-.5Zm-.5 1.782c-1.283.156-2.131 1.036-2.131 1.927 0 .89.848 1.77 2.132 1.927V7.25l-.001-.001Zm1 4.94v3.799c.53-.077 1.01-.253 1.382-.499.503-.332.764-.759.764-1.222 0-.483-.283-1.013-.805-1.44a3.142 3.142 0 0 0-1.34-.638H12.5Z",
    clipRule: "evenodd"
  })]
});